
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="type-modal" [formGroup]="newRoleForm">
    <div class="card">
      <h3 class="green decoration mb-4">Detalles del rol</h3>

      <div class="form-wrapper mb-3" [class.control-invalid]="newRoleForm.get('name_role').dirty && newRoleForm.get('name_role').invalid">
        <span>Nombre:</span>
        <input type="text" formControlName="name_role" placeholder="Ej: Sergio Miguel" [attr.disabled]="true">
        <p *ngIf="newRoleForm.get('name_role').dirty && newRoleForm.get('name_role').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newRoleForm.get('name_role').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newRoleForm.get('display_name_role').dirty && newRoleForm.get('display_name_role').invalid">
        <span>Detalle:</span>
        <input type="text" formControlName="display_name_role" placeholder="Ej: Luján Mora" [attr.disabled]="true">
        <p *ngIf="newRoleForm.get('display_name_role').dirty && newRoleForm.get('display_name_role').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newRoleForm.get('display_name_role').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3">
        <span style="padding: 0 15px;">Permisos:</span>
        <cdk-accordion class="example-accordion">
          <cdk-accordion-item *ngIf="permissions.commercial_agreements"
            #accordionItem="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-0'"
            [expanded]="true"
            [attr.aria-expanded]="accordionItem.expanded"
            [attr.aria-controls]="'accordion-body-0'">
            <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
              Acuerdos comerciales
              <span class="example-accordion-item-description">
                {{ accordionItem.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-0'"
              [attr.aria-labelledby]="'accordion-header-0'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.commercial_agreements" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.payments"
            #accordionItem1="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-1'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem1.expanded"
            [attr.aria-controls]="'accordion-body-1'">
            <div class="example-accordion-item-header" (click)="accordionItem1.toggle()">
              Pagos
              <span class="example-accordion-item-description">
                {{ accordionItem1.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem1.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-1'"
              [attr.aria-labelledby]="'accordion-header-1'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.payments" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.due_payments"
            #accordionItem2="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-2'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem2.expanded"
            [attr.aria-controls]="'accordion-body-2'">
            <div class="example-accordion-item-header" (click)="accordionItem2.toggle()">
              Deudas
              <span class="example-accordion-item-description">
                {{ accordionItem2.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem2.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-2'"
              [attr.aria-labelledby]="'accordion-header-2'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.due_payments" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.invoices"
            #accordionItem3="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-3'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem3.expanded"
            [attr.aria-controls]="'accordion-body-3'">
            <div class="example-accordion-item-header" (click)="accordionItem3.toggle()">
              Facturación
              <span class="example-accordion-item-description">
                {{ accordionItem3.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem3.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-3'"
              [attr.aria-labelledby]="'accordion-header-3'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.invoices" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.products"
            #accordionItem4="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-4'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem4.expanded"
            [attr.aria-controls]="'accordion-body-4'">
            <div class="example-accordion-item-header" (click)="accordionItem4.toggle()">
              Productos
              <span class="example-accordion-item-description">
                {{ accordionItem4.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem4.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-4'"
              [attr.aria-labelledby]="'accordion-header-4'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.products" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.organizations"
            #accordionItem5="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-5'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem5.expanded"
            [attr.aria-controls]="'accordion-body-5'">
            <div class="example-accordion-item-header" (click)="accordionItem5.toggle()">
              Comercios
              <span class="example-accordion-item-description">
                {{ accordionItem5.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem5.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-5'"
              [attr.aria-labelledby]="'accordion-header-5'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.organizations" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.users"
            #accordionItem6="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-6'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem6.expanded"
            [attr.aria-controls]="'accordion-body-6'">
            <div class="example-accordion-item-header" (click)="accordionItem6.toggle()">
              Usuarios
              <span class="example-accordion-item-description">
                {{ accordionItem6.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem6.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-6'"
              [attr.aria-labelledby]="'accordion-header-6'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.users" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.roless"
            #accordionItem7="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-7'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem7.expanded"
            [attr.aria-controls]="'accordion-body-7'">
            <div class="example-accordion-item-header" (click)="accordionItem7.toggle()">
              Roles
              <span class="example-accordion-item-description">
                {{ accordionItem7.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem7.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-7'"
              [attr.aria-labelledby]="'accordion-header-7'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.roless" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
          <cdk-accordion-item *ngIf="permissions.permissions"
            #accordionItem8="cdkAccordionItem"
            class="example-accordion-item"
            role="button"
            tabindex="0"
            [attr.id]="'accordion-header-8'"
            [expanded]="false"
            [attr.aria-expanded]="accordionItem8.expanded"
            [attr.aria-controls]="'accordion-body-8'">
            <div class="example-accordion-item-header" (click)="accordionItem8.toggle()">
              Permisos
              <span class="example-accordion-item-description">
                {{ accordionItem8.expanded ? 'cerrar' : 'expandir' }}
              </span>
            </div>
            <div
              class="example-accordion-item-body"
              role="region"
              [style.display]="accordionItem8.expanded ? '' : 'none'"
              [attr.id]="'accordion-body-8'"
              [attr.aria-labelledby]="'accordion-header-8'">
              <div class="toogle-wrapper">
                <mat-slide-toggle style="pointer-events: none;" *ngFor="let permission of permissions.permissions" [checked]="checks[permission.id]" (change)="changePermission($event, permission.id)" [id]="permission.id">{{ permission.display_name }}</mat-slide-toggle>
              </div>
            </div>
          </cdk-accordion-item>
        </cdk-accordion>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <!-- <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
